import(/* webpackMode: "eager" */ "/home/click-builder/cresivox/live/builder/src/app/error.tsx")